import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Toolbar } from 'primeng/toolbar';

@Component({
  selector: '',
  template: `
    <p-toolbar
      ><ng-template #start
        ><h1>Login fehlgeschlagen</h1></ng-template
      ></p-toolbar
    >

    <div class="bd-container-inner">
      <span>Versuchen Sie bitte folgende Dinge, um das Problem zu lösen</span>
      <ul>
        <li>
          Browser Cache leeren -
          <a href="https://browser-cache-leeren.de/detect.html"
            >Wie leere ich den Cache eines Browsers ?</a
          >
        </li>
        <li>Seite neu laden</li>
      </ul>
    </div>

    <div class="bd-container-inner">
      <span
        >Falls dieser Fehler immer wieder auftritt, wenden Sie sich bitte an
        unseren
        <a href="https://www.bindoc.de/support">BinDoc Support</a>.</span
      >
    </div>
  `,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Toolbar],
})
export class BdSecurityAuthenticationLoginFailedComponent {}
